import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/services/app-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent implements OnInit {

  guid = 'No-Code';
  bookId = '';
  constructor(private router: Router, private toastrService: ToastrService,
    private appService: AppService,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe((res: any) => {
      if (res.guid) {
        this.guid = res.guid;

        // blunder management: redirect 93f26d12-2391-4b58-88a2-22d54bb78879 to more-info
        if (this.guid === '93f26d12-2391-4b58-88a2-22d54bb78879') {
          this.router.navigate(['more-info']);
          return;
        }
        this.appService.validateQr(res.guid).subscribe((res: any) => {
          if (!res.valid) {
            this.toastrService.error(res.message, "Please Try With valid activation code");
            this.router.navigate(['home']);
          } else if (res.inUse) {
            this.toastrService.error("Account is Active For this Code", "Please Try With other activation code");
            this.router.navigate(['home']);
          }
          this.bookId = res.book_id;
        });
      }
    })
  }

  public otp: any = false;
  policy_number: string = '';
  email_Id: string = "";
  hasError: boolean = false;
  hasSError: boolean = false;
  ErrorMessage: string = "";
  resendLinkEmailID: string = "";
  loginForm: any;
  otpForm: any;

  isShowOtpPage: any;
  isShowSignup: any;
  hidePassword = true;
  hideConfirmPassword = true;
  minAge = 18;
  minAgeDate: Date = new Date(new Date().setFullYear(new Date().getFullYear() - this.minAge));
  
  ngOnInit() {
    this.loginForm = new FormGroup({
      password: new FormControl('', [Validators.required, Validators.minLength(8)]),
      "firstName": new FormControl('', [Validators.required, Validators.minLength(3)]),
      "lastName": new FormControl('', [Validators.required]),
      "displayName": new FormControl(''),
      "email": new FormControl('', [Validators.required, Validators.email]),
      "phone": new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]),
      "status": new FormControl('Pending'),
      "dob": new FormControl('', [Validators.required]),
      "occupation": new FormControl('', [Validators.required]),
      "cPassword": new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(20)]),
      "guid": new FormControl(this.guid),
      "book_id": new FormControl(this.bookId || '0125c44c-dbaf-4ab5-adf9-f040592b968e'),
    }, { validators: this.passwordMatchValidator });
  }

  passwordMatchValidator(group: AbstractControl): { [key: string]: boolean } | null {
    const password = group.get('password')?.value;
    const cPassword = group.get('cPassword')?.value;
    return password === cPassword ? null : { passwordMismatch: true };
  }

  ngAfterViewInit() {

  }

  onSubmit() {
    if (this.loginForm.valid) {
      let data = this.loginForm.value;
      this.appService.hashPassword(this.loginForm.value.password).then((res: any) => {
        data.password = res;
        delete data['cPassword'];
        data['dob'] = new Date(data['dob']).toISOString().substring(0, 10);
        data['displayName'] = data['firstName'] + ' ' + data['lastName'];
        this.appService.signUp(data).subscribe((res: any) => {
          if(res.message) {
            this.toastrService.error(res.message, 'Error');
            return;
          }
       
          this.appService.sendEmail({
            recipient_email: data.email,
            subject: 'Account Activation',
            message: `Hello <b>${data.displayName}</b>,<br/><br/>Please click the link below to activate your account:\n\n<a href="${environment.siteUrl}activate/${res.id}">Account Activation</a><br/><br/>
            Thank you!<br/>P. Sharani Team<br/>`
          }).subscribe((res: any) => {
            this.toastrService.success('Please check your email for activation link', 'User Details are Saved and Activation Link Sent to your Email ID');
            this.router.navigate(["/login"]);
          }, (err) => {
            this.toastrService.error('Error Sending Activation Link', 'Please try again later');
          });
         
        }, (err) => {
          this.toastrService.error('Invalid Details', 'User Details are invalid');
        });
      });
    } else {
      this.toastrService.warning('Invalid Details', 'Please Provide User Details');
    }
  }

  goToSignUp() {
    this.router.navigate(["/signup"]);
  }

  togglePasswordVisibility(field: string) {
    if (field === 'password') {
      this.hidePassword = !this.hidePassword;
    } else if (field === 'confirm') {
      this.hideConfirmPassword = !this.hideConfirmPassword;
    }
  }
}